import { createContext } from 'react';

export const ProductContext = createContext<any>({});

export const initProductContext = {
  sort: [{ columnName: 'time', direction: 'desc' }],
  hiddenColumnNames: [],
};

export const productReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'setSort':
      return { ...state, sort: action.payload };
    case 'setHiddenColumnNames':
      return { ...state, hiddenColumnNames: action.payload };
    default:
      throw new Error('Unexpected action');
  }
};
